export const calculateUserStats = (history, activeSeason, timeframe = 'alltime') => {
  const data = timeframe === 'monthly' 
    ? history.filter(item => (item.createdAt >= activeSeason.startDate && item.createdAt < activeSeason.endDate))
    : history;

  const stats = {
    shop: {
      totalSpent: 0,
      rouletteSpent: 0,
      rouletteWon: 0,
      jackpots: 0,
      xpBoostersCount: 0, // Новое
      proBoostersCount: 0  // Новое
    },
    betting: {
      totalSpent: 0,
      totalWon: 0,
      count: 0,
      winsCount: 0,
      biggestWin: { value: 0, reason: '' }, // Изменено
      biggestLoss: { value: 0, reason: '' }, // Изменено
      favoriteTeam: { name: 'Нет', count: 0 }, // Изменено
      teams: {}
    }
  };

  data.forEach(item => {
    const pts = item.points;
    const cat = item.category;
    const reason = item.reason || '';

    // --- ЛАВКА ---
    if (cat === 'Покупка') {
      if (pts < 0) stats.shop.totalSpent += Math.abs(pts);
      
      // Поиск XP-бустеров
      if (reason.includes('очков опыта')) {
        stats.shop.xpBoostersCount += 1;
      }
      // Поиск PRO-бустеров
      if (reason.includes('PRO-Бустер')) {
        stats.shop.proBoostersCount += 1;
      }
    }
    
    if (cat === 'Рулетка') {
      if (pts < 0) {stats.shop.totalSpent += Math.abs(pts); stats.shop.rouletteSpent += Math.abs(pts);}
      else stats.shop.rouletteWon += Math.abs(pts);
      if (reason.includes('ДЖЕКПОТ')) stats.shop.jackpots += 1;
    }

    // --- БЕТТИНГ ---
    if (cat === 'Беттинг' || cat === 'Беттинг (Событие)') {
      if (pts < 0) {
        const absPts = Math.abs(pts);
        stats.betting.totalSpent += absPts;
        stats.betting.count += 1;

        // Фиксируем крупнейший проигрыш и его причину
        if (absPts > stats.betting.biggestLoss.value) {
          stats.betting.biggestLoss = { value: absPts, reason: reason.replace('Ставка на ', '') };
        }
        
        // Парсинг команды
        const teamMatch = reason.match(/Ставка на (.+?) \(vs/);
        if (teamMatch) {
          const team = teamMatch[1];
          stats.betting.teams[team] = (stats.betting.teams[team] || 0) + 1;
        }
      } else {
        stats.betting.totalWon += pts;
        stats.betting.winsCount += 1;

        // Фиксируем пиковый выигрыш и его причину
        if (pts > stats.betting.biggestWin.value) {
          stats.betting.biggestWin = { value: pts, reason: reason.replace('Победа: ', '') };
        }
      }
    }
  });

  // Расчет любимой команды
  let maxBets = 0;
  for (const [name, count] of Object.entries(stats.betting.teams)) {
    if (count > maxBets) {
      maxBets = count;
      stats.betting.favoriteTeam = { name, count };
    }
  }

  return stats;
};